import { PageTitle } from "@/components/custom/PageTitle"
import { useForm } from "react-hook-form"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import { Button } from "@/components/ui/button"
import { Form } from "@/components/ui/form"
import { TextInputField } from "@/components/custom/InputField/TextInputField"
import { TCS } from "@/constants/TCS/TCS"
import { getFormProps } from "@/helpers/formHelpers"

const formSchema = z.object({
  message: z.string().min(1, {
    message: 'Please type a message.'
  }),
})

export const SupportPage = () => {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      message: "",
    },
  })
  const formProps = getFormProps(form, formSchema)

  const onFormSubmit = (
    values: z.infer<typeof formSchema>
  ) => {
    console.log(values)
  }

  return (
    <div className="protectedPageLayout">
      <PageTitle title="Support" hasSubtitle />
      <p className="big-textArea text-primary text-left text-base font-normal leading-5 mb-10">
        We are happy to help if you have any questions.
        Send us a message or email us directly at {' '}
        <a
          className="text-accent underline font-semibold h-1"
          href={`mailto:${TCS.SUPPORT_EMAIL}`}
        >
          {TCS.SUPPORT_EMAIL}.
        </a>
      </p>

      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onFormSubmit)}
          className="space-y-8 flex flex-col items-start"
        >
          <TextInputField
            name="message"
            label="Message"
            type="textarea"
            placeholder="Type your message here..."
            error={!!form.formState.errors.message}
            required={true}
            {...formProps}
          />
          <Button type="submit" className="mb-2 font-semibold">
            Send Message
          </Button>
        </form>
      </Form>
    </div>
  )
}
